import Editor from '@tinymce/tinymce-vue'
import Vue from 'vue';
import KEYS from '../../../values/keys';

export default Vue.component('ed-text', { 
  name: 'ed-text',
  inheritAttrs: false,
  props: [
    'height',
    'disabled',
    'limit'
  ],
  computed: {
    fieldHeight() {
      return this.height ? this.height : 500;
    },
    isPresentationMode() {
      return this.$store.state.CourseStore.isPresentationStudentMode || this.$store.state.CourseStore.isPresentationTeacherMode;
    },
    isDisabled() {
      return this.disabled || this.isPresentationMode;
    }
  },
  components: {
    editor: Editor
  },
  data: () => {
    return {
      value: '',
      blurred: false,
      tinyApiKey: KEYS.TINY_API_KEY,
    }
  },
  validations() {
    return {
      value: this.$attrs.value ? this.$attrs.value.validators : {}
    };
  },
  methods: {
    onKeyDown(event) {
      const editor = this.$refs.Editor.editor;

      if (this.limit) {
        const text = editor.getContent({ format: 'text' });
        
        if (event.key !== 'Backspace') {
          if (text.length >= this.limit) {
            event.preventDefault();
  
            return;
          }
        }
      }

      this.setValue();
    },
    setValue() {
      this.checkEmptyText();
      this.$emit('input', {
        value: this.value,
        valid: !this.$v.value.$invalid,
        validators: this.$attrs.value.validators
      });
    },
    setBlur() {
      this.blurred = true;
    },
    getContent(content) {
      this.$emit('content', content);      
    },
    setReadOnly() {
      this.$refs.Editor.editor.mode.set('readonly');
    },
    unsetReadOnly() {
      this.$refs.Editor.editor.mode.set('design');
    },
    checkEmptyText() {
      if(this.$refs.Editor && this.$refs.Editor.editor &&
          this.$refs.Editor.editor.getContent({format:'text'}).trim().length === 0) {
        this.value = '';
      }
    }
  },
  created() {
    this.$attrs.value.validators = this.$attrs.value.validators ? this.$attrs.value.validators : {};
    this.value = this.$attrs.value.value;
    this.setValue();
  },
  beforeDestroy() {
    this.$refs.Editor.editor.save();
    this.$refs.Editor.editor.remove();
  },
  watch: {
    $attrs() {
      this.value = this.$attrs.value ? this.$attrs.value.value : '';
    }
  }
});